// extracted by mini-css-extract-plugin
export default {"street":"edit_street__066we"};